import type { ReactNode } from 'react';

/**
 * SplitFlap "departures-board" text flip — the green pill's hover feedback, 1:1 with the design
 * system's `.flap` (docs/brand/alchmy-design-system.html). Two copies of the label are the front +
 * under faces of a shallow prism that rotates 90° about its x-axis on hover/focus (one rigid move).
 * The `.flap` CSS (index.css) gates the motion to fine-pointer + no-reduced-motion; otherwise the
 * static label just shows. Wrap a GREEN PILL's text label in it; any icon / number badge sits
 * OUTSIDE the flap (as a sibling of <FlapText>). The under face is aria-hidden so screen readers
 * read the label once.
 */
export function FlapText({ children }: { children: ReactNode }) {
  return (
    <span className="flap">
      <span className="flap__prism">
        <span className="flap__face flap__face--front">{children}</span>
        <span className="flap__face flap__face--under" aria-hidden="true">
          {children}
        </span>
      </span>
    </span>
  );
}
